import { steps } from "@/mocks/home";

export default function Steps() {
  return (
    <section id="how" className="relative bg-background-100 py-20 md:py-24 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="reveal">
            <div className="inline-flex items-center gap-2 rounded-full border border-background-300/40 px-4 py-1.5 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-400"></span>
              <span className="text-xs font-medium text-foreground-800 tracking-wide">
                How to get started
              </span>
            </div>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-normal text-foreground-950 leading-tight tracking-tight">
              You&apos;re live before
              <br className="hidden sm:block" /> your next meeting
            </h2>
          </div>
          <p className="reveal text-sm md:text-base text-foreground-700 leading-relaxed max-w-sm">
            No developer. No IT team. Joble reads your business and starts working the moment you
            connect it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((step) => (
            <div key={step.number} className="reveal flex flex-col">
              <div className="font-heading text-4xl md:text-5xl font-semibold text-accent-400 mb-4">
                {step.number}
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-2.5">{step.title}</h3>
              <p className="text-sm text-foreground-700 leading-relaxed mb-6">{step.description}</p>
              <div className="mt-auto h-0.5 w-full rounded-full bg-background-300/50"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}